import { useStore } from 'effector-react'
import * as React from 'react'

import { $history, getHistories, historyMounted } from './model'

export const useHistoriesWidget = (clientId: string) => {
  React.useEffect(() => {
    historyMounted(clientId)
  }, [])

  const history = useStore($history)

  const loading = useStore(getHistories.pending)

  return {
    history,
    loading,
  }
}
